import { SimpleDatePicker } from "@/components/DatePicker/SimpleDatePicker";
import Input from "@/components/Input/Input";
import { HStack, Spacer, VStack } from "@/components/Layout";
import AddStepperNavigation from "@/components/Navigation/StepperNavigation";
import AddStepperStepTitleCardComponent from "@/components/Stepper/AddStepperStepTitleCard";
import DockAddStepperAction from "@/components/Stepper/DockAddStepperAction";
import { Text } from "@/components/Typography/Text";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { formatISODate } from "@/utils/date";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useStartOrganizationPlan } from "./-query";

export const Route = createFileRoute("/_staff/organization/plan/create/")({
  component: RouteComponent,
});

function RouteComponent() {
  const [name, setName] = useState("");
  const [applyDate, setApplyDate] = useState<Date | undefined>(undefined);
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.organization.plan.create",
  });
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useStartOrganizationPlan();

  const handleSubmit = async () => {
    if (!name || !applyDate) return;
    await mutateAsync({
      name,
      applyPlanDate: formatISODate(applyDate),
      // NOTE: baseDate, Descriptionの入力ないので省略
    });
    // NOTE: 実行結果never型なので一覧に遷移
    navigate({ to: "/organization/plan" });
  };

  const isDisabled = !name || !applyDate || isPending;

  return (
    <HStack className="p-10">
      <AddStepperNavigation
        link={{ hash: "1", to: "/organization/plan/add" }}
        title={t("title")}
        sections={[{ label: t("steps.organizationPlanInfo"), hash: "1" }]}
      />
      <Spacer variant="l" />
      <VStack className="gap-6 min-w-[560px]">
        <AddStepperStepTitleCardComponent
          stepName={t("organizationPlanInfoStep.title")}
        />
        <VStack className="bg-neutral-fill p-6 gap-4">
          <VStack className="gap-2">
            <Text variant="label">{t("organizationPlanInfoStep.name")}</Text>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="-"
            />
          </VStack>
          <VStack className="gap-2">
            <Text variant="label">
              {t("organizationPlanInfoStep.effectiveDate")}
            </Text>
            <SimpleDatePicker
              value={applyDate}
              onChange={(d) => setApplyDate(d)}
              disablePast
            />
          </VStack>
        </VStack>
        <div className="mb-32">
          <DockAddStepperAction
            baseLink="/organization/plan/add"
            previousPage={null}
            nextPage={null}
            nextComplete
            disabled={isDisabled}
            onNextClick={handleSubmit}
            onCompleteClick={handleSubmit}
          />
        </div>
      </VStack>
    </HStack>
  );
}
